import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions from 'actions';
import LoadingView from 'components/view/loading';
import EditPage from '../components/content/page/edit';
import NotFoundPage from 'components/pages/error/404';
import { confirmRouteLeave, confirmPageLeave } from 'utils/container';

export const mapStateToProps = (state) => ({
  content: state.content,
  record: state.data.record,
  lookup: state.lookup,
  loading: state.attributes.loading,
  errors: state.data.recordErrors,
});

export const mapDispatchToProps = (dispatch) => ({
  fetchRecord: (id) => {
    return dispatch(actions.data.fetchRecord('content/pages', id));
  },

  updateRecord: (id, data) => {
    return dispatch(actions.data.updateRecord('content/pages', id, data));
  },

  deleteRecord: (id) => {
    return dispatch(actions.data.deleteRecord('content/pages', id));
  },
});

export class EditContentPage extends React.PureComponent {
  static contextTypes = {
    notifyError: PropTypes.func.isRequired,
    notifyDeleted: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
  };

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      edited: false,
      values: {},
      onSubmitRecord: this.onSubmitRecord.bind(this),
      onChangeForm: this.onChangeForm.bind(this),
      onClickDelete: this.onClickDelete.bind(this),
    };
  }

  componentDidMount() {
    const { params, fetchRecord } = this.props;

    confirmRouteLeave(this);

    fetchRecord(params.id).then((record) => {
      this.setState({
        loaded: true,
        values: { ...record },
      });
    });
  }

  componentWillUnmount() {
    confirmPageLeave(this);
  }

  onChangeForm = (values, edited) => {
    this.setState((state) => ({
      values: { ...state.values, ...values },
      edited,
    }));
  };

  /** @param {React.MouseEvent} event */
  onClickDelete(event) {
    const { record, params, router, deleteRecord } = this.props;
    event.preventDefault();

    this.context.openModal('ConfirmDelete', {
      title: record.title ?? record.name,
      onConfirm: () => {
        deleteRecord(params.id).then((result) => {
          if (result && !result.errors) {
            this.setState({ edited: false }, () => {
              router.replace('/content/pages');
              this.context.notifyDeleted('Page');
            });
          }
        });
      },
    });
  }

  async onSubmitRecord(values) {
    const { params, updateRecord } = this.props;

    const result = await updateRecord(params.id, values);

    if (result) {
      if (result.errors) {
        this.context.notifyError(result.errors);
      } else {
        this.setState({
          edited: false,
          values: { ...result },
        });
      }
    }
  }

  render() {
    if (!this.state.loaded) {
      return <LoadingView />;
    }

    if (!this.props.record) {
      return <NotFoundPage />;
    }

    return <EditPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditContentPage);
